module.exports = __webpack_public_path__ + "img/cycle_logo_2.f13c375c.jpg";